import React from 'react'
import { useEffect, useState } from "react";

export const AllQuestions = () => {

    const [rows, setRows] = useState([]);
      const [columns, setColumns] = useState([]);
    
    
       useEffect(() => {
        async function fetchData() {
          try {
            // const res = await fetch("https://dev.bibhup.co.in/webhook-test/allQuestions");
            const res = await fetch("https://dev.bibhup.co.in/webhook/allQuestions");
            const data = await res.json();
            
            // Remove the FIRST ROW (header row of your sheet)
            const filteredRows = data.slice(0);
    
            setRows(filteredRows);
    
            if (data.length > 0) {
              // Remove FIRST COLUMN (usually row_number)
              const filteredCols = Object.keys(data[0]).slice(1);
              setColumns(filteredCols);
            }
          } catch (err) {
            console.error("Error fetching:", err);
          }
        }
        fetchData();
      }, []);


  return (
    <div className="w-full h-full"  style={{ padding: "20px" }}> 
    {/* Scroll wrapper: fills parent height and provides both scrollbars */}
          <div className="w-full h-full bg-white border border-gray-300 overflow-auto">
            {/* Table: min-w-max so it can grow horizontally based on content */}
            <table className="min-w-max border-collapse text-sm">
              <thead className="bg-gray-200 sticky top-0 z-10">
                <tr>
                  {columns.map((col) => (
                    <th key={col} className="border px-3 py-2 text-left font-semibold">
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {rows.map((row, rIdx) => (
                  <tr key={rIdx} className="odd:bg-gray-50 even:bg-white align-top">
                    {columns.map((col) => (
                      <td
                        key={col}
                        // whitespace-nowrap forces horizontal growth; change to normal if you want wrapping
                        className="border px-3 py-1 whitespace-nowrap align-top max-w-[380px] overflow-hidden text-ellipsis"
                      >
                        {row[col] === "" || row[col] === null ? "-" : String(row[col])}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div></div>
  )
}
